/*
 *   File : sidebar.js
 *   Author : https://evoqins.com
 *   Description : Left navigation component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import { useLocation, useNavigate } from "react-router-dom";

//Custom style
import styles from "../../Style/Components/left.module.scss";

//Custom component
import Icon from "../icons";

const LEFT_ITEMS = [
  {
    icon: "dashboard",
    label: "Dashboard",
    path: "/",
    child_path: [],
  },

  {
    icon: "manage-sub-admin",
    label: "Manage Sub Admin",
    path: "/manage-sub-admin",
    child_path: [
      "/manage-sub-admin/detail",
      "/manage-sub-admin/edit",
      "/manage-sub-admin/add",
    ],
  },

  {
    icon: "users",
    label: "Users",
    path: "/users",
    child_path: ["/users/detail"],
  },

  {
    icon: "orders",
    label: "Orders",
    path: "/orders",
    child_path: ["/orders/detail"],
  },
  {
    icon: "mfd-management",
    label: "MFD Management",
    path: "/mfd-management",
    child_path: ["/mfd-management"],
  },
  {
    icon: "revenue-payout",
    label: "Revenue & Payouts",
    path: "/revenue-payouts",
    child_path: ["/revenue-payouts"],
  },
  {
    icon: "manage-risk-score",
    label: "Manage Risk Score",
    path: "/manage-risk-score",
    child_path: [
      "/manage-risk-score/risk/edit",
      "/manage-risk-score/add",
      "/manage-risk-score/edit",
    ],
  },

  {
    icon: "manage-goal",
    label: "Manage Goal",
    path: "/manage-goal",
    child_path: ["/manage-goal/add", "/manage-goal/detail"],
  },

  {
    icon: "manage-basket",
    label: "Manage Basket",
    path: "/manage-basket",
    child_path: ["/manage-basket/add", "/manage-basket/detail"],
  },

  {
    icon: "manage-story",
    label: "Manage Story",
    path: "/manage-story",
    child_path: ["/manage-story/edit", "/manage-story/add"],
  },

  {
    icon: "manage-content",
    label: "Manage Content",
    path: "/manage-content",
    child_path: [
      // Notifications
      "/manage-content/notification",
      "/manage-content/notification/add",

      // FAQ
      "/manage-content/faq",
      "/manage-content/faq/add",
      "/manage-content/faq/edit",

      // Terms
      "/manage-content/terms-conditions",
      "/manage-content/terms-conditions/edit",

      // Privacy Policy
      "/manage-content/privacy-policy",
      "/manage-content/privacy-policy/edit",

      // Disclosure
      "/manage-content/disclosure",
      "/manage-content/disclosure/edit",
    ],
  },
];

const Sidebar = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const _handleTabChange = (data) => {
    navigate(data.path);
    if (props.type === "offcanvas") props.handleCloseOffCanvas();
  };

  const _isActive = (data) =>
    data.path === location.pathname ||
    data.child_path.some((path) => location.pathname.includes(path));

  return (
    <div
      className={` ${styles.e_sidebar} rounded-32 position-sticky overflow-hidden position-relative top-0 left-0 min-h-100vh ${props.toggle === false ? "px-2 py-3" : "p-3"}`}
    >
      {props.toggle === false ? (
        // Compact full-width strip so the badge fits the narrow collapsed column
        <div className="text-facebook-blue fw-400 fs-8 lh-16 bg-lavender-blue position-absolute top-0 start-0 end-0 text-center text-nowrap border-bottom border-white">
          Super Admin
        </div>
      ) : (
        <div className="text-facebook-blue fw-400 fs-10 lh-16 bg-lavender-blue position-absolute top-0 end-0 rounded-bl-12 pe-3 border border-white ps-2">
          Super Admin
        </div>
      )}
      <div
        className={`${props.toggle === false ? "py-25" : "p-24"} d-flex justify-content-center`}
      >
        {props.toggle === false ? (
          <img
            src={require("../../Assets/Images/logo-icon.svg").default}
            draggable={false}
            className="e-cursor-pointer"
            width="28px"
            alt="logo"
            onClick={() => navigate("/")}
          />
        ) : props.toggle || props.type === "offcanvas" ? (
          <img
            src={require("../../Assets/Images/logo.png")}
            draggable={false}
            className="img-fluid e-cursor-pointer px-2"
            width={props.type === "offcanvas" ? "200px" : "148px"}
            alt="logo"
            onClick={() => {
              if (props.type === "offcanvas") {
                props.handleCloseOffCanvas();
                props.toggleHam?.();
              }
              navigate("/");
            }}
          />
        ) : (
          <img
            src={require("../../Assets/Images/logo.png")}
            draggable={false}
            className="img-fluid e-cursor-pointer"
            width={props.type === "offcanvas" && "200px"}
            alt="logo"
            onClick={() => {
              if (props.type === "offcanvas") {
                props.handleCloseOffCanvas();
                props.toggleHam?.();
              }
              navigate("/");
            }}
          />
        )}
      </div>
      <div
        className={`p-0 d-flex row-gap-3 flex-column transition max-h-zoom-100vh overflow-scroll ${styles.e_left_nav_scroll}`}
      >
        {LEFT_ITEMS.map((data, key) => (
          <div key={key}>
            {props.toggle === false ? (
              <div
                className={`${
                  _isActive(data) ? styles.e_tab_active : styles.e_tab
                } transition e-cursor-pointer d-flex justify-content-center p-12 rounded-12 text-eerie-black`}
                title={data.label}
                onClick={() => _handleTabChange(data)}
              >
                <Icon icon={data.icon} size="20px" />
              </div>
            ) : (
              <div
                className={`${
                  _isActive(data) ? `${styles.e_tab_active}` : `${styles.e_tab} `
                } transition e-cursor-pointer d-flex column-gap-2 p-12 align-items-center rounded-12`}
                onClick={() => _handleTabChange(data)}
              >
                <Icon icon={data.icon} size="20px" />

                <p className="transition text-eerie-black mb-0 lh-20 fs-16 fw-500">
                  {data.label}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;
